import * as React from "react";
import SelectAddress from "../../select/SelectAddress";
import Address from "../../../../model/address/Address";
import {FocusableProps} from "../../../common/props/FocusableProps";
import {FormGroupProps} from "../../../common/props/FormGroupProps";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

interface ComponentProps {
	/**
	 * On icon click
	 */
	onIconClick?: () => void;
	/**
	 * Icon hover text
	 */
	iconTooltipText?: string
	/**
	 * Icon image
	 */
	icon?: string
}

type Props = FormGroupProps<Address> & FocusableProps & ComponentProps

/**
 * Address form view.
 */
export default class AddressFormGroup extends React.PureComponent <Props, {}> {
	render() {
		return (
			<FormGroup label={this.props.label}
					   error={this.props.field.firstError().getOrElse("")}
					   iconTooltipText={this.props.iconTooltipText}
					   onIconClick={this.props.onIconClick}
					   icon={this.props.icon}>
				<SelectAddress value={this.props.field.value}
							   onChange={value => this.props.onChange(this.props.field.updateValue(value))}
							   focus={this.props.form && this.props.form.hasFocus(this.props.field)}
							   placeholder={"Search address"}
							   onFocus={() => {
								   this.props.onFocus && this.props.onFocus();
								   this.props.onFocusChange && this.props.onFocusChange(this.props.field);
							   }}/>
			</FormGroup>
		);
	}
}